<template>
  <div>
    <div>
      <vs-row>
        <vs-col>
          <span class="bold-text" style="font-size: 18px;"> 순회점검(주1회), 합동 안전․보건점검(분기1회)</span>
        </vs-col>
      </vs-row>
      <vs-row class="my-4">
        <vs-col><h5><i class="dot"></i>건설공사발주자의 의무</h5></vs-col>
      </vs-row>

      <vs-row class="mb-8">
        <vs-col>
          <table>
            <colgroup>
              <col>
              <col width="200" />
            </colgroup>
            <thead>
            <tr>
              <th>
                <p class="px-4 bold-text">공사를 지배·운영·관리하지 않을 시</p>
                <p class="normal-text ml-4">※ 발주자일지라도 지배·운영·관리하는 경우 도급인에 해당</p>
              </th>
              <th>
                <p class="px-4 bold-text">총 공사금액</p>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>
                <div>
                  <p class="semi-bold-text">1. 건설공사 단계별 안전보건대장 작성[제 67조]</p>
                  <p class="normal-text ml-4">㉠ (건설공사 계획 시) <b>기본안전보건대장 작성</b></p>
                  <p class="normal-text ml-4">㉡ (설계계약 체결 시)기본안전보건대장을 설계자에게 <b>제공</b></p>
                  <p class="normal-text ml-4">㉢ (건설공사계약 체결 시) 설계안전보건대장을 수급인이게 <b>제공</b></p>
                  <p class="normal-text ml-4">㉣ 설계자의 설계안전보건대장 작성 <b>확인</b>(필요시 보완요청)</p>
                  <p class="normal-text ml-4">㉤ 수급인의 공사안전보건대장 작성 <b>확인</b></p>
                  <p class="normal-text ml-4">㉥ 설계·공사안전보건대장에 따른 수급인의 산업재해 예방조치 이행여부 확인</p>
                  <p class="normal-text ml-8">☞ 공사시작 후 <b>분기마다 1회 이상</b></p>
                  <p class="normal-text ml-8">※ 건설안전기술사 등의 전문가를 선임하여 업무 수행 가능</p>
                  <p class="normal-text ml-4">㉦ 소속 임직원을 지정하여 <b>안전보건대장의 작성 및 확인 등의 업무를 수행</b></p>
                  <p class="normal-text ml-8">※ 건설안전기술사 등의 전문가를 선임하여 업무 수행 가능</p>
                  <p class="normal-text ml-4">㉧ 수급인이 공사안전보건대장에 따른 안전보건 조치 등을 이행하지 아니하여 산업재해가 <b>발생할 급박한 위험이 있을 때에는 수급인에게 작업 중단을 요청</b></p>
                  <p class="semi-bold-text">2. 안전보건조정자 선임[제 68조]</p>
                  <p class="normal-text ml-4">같은 장소에서 2개 이상 공사 도급시, 작업 혼재로 인한 산재예방을 위해 (실제)착공일 전날까지 <b>안전보건조정자를 선임</b> → 각 도급인에게 통보</p>
                </div>
              </td>
              <td>
                <p class="semi-bold-text">50억원 이상</p>
              </td>
            </tr>
            <tr>
              <td>
                <div>
                  <p class="semi-bold-text">3. 건설재해예방전문지도기관과 기술지도 계약 체결[제73조]</p>
                  <p class="normal-text ml-4">☞ 최소 월 2회 기술지도 실시</p>
                  <p class="normal-text ml-4">※ 예외 : ㉠ 전담 안전관리자 선임   ㉡ 유해위험방지계획서 제출 대상   ㉢ 공사기간 1개월 미만   ㉣ 육지와 연결되지 않은 섬 지역(제주는 제외)</p>
                </div>
              </td>
              <td>
                <p class="semi-bold-text">1억원 이상 120억원 미만</p>
                <p class="normal-text">(토목공사는150억원 미만)</p>
              </td>
            </tr>
            <tr>
              <td>
                <div>
                  <p class="semi-bold-text">4. 도급계약 체결 시 도급금액에 산업안전보건관리비 계상[제72조]</p>
                </div>
              </td>
              <td>
                <p class="semi-bold-text">2천만원 이상</p>
              </td>
            </tr>
            <tr>
              <td>
                <div>
                  <p class="semi-bold-text">5. 공사기간 단축 및 (정당한 사유 없는) 공법 변경 금지[제69조]</p>
                  <p class="semi-bold-text">6. 일정 사유에 의한 공사기간 연장[제70조]</p>
                  <p class="normal-text ml-4">㉠ 악천후 등 <b>불가항력의 사유</b></p>
                  <p class="normal-text ml-4">㉡ <b>발주자에게 책임이 있는 사유</b>로 착공이 지연되거나 시공이 중단된 경우</p>
                  <p class="normal-text ml-4">☞ 수급인이 <b>공사기간 연장 요청하면 연장 조치(요청일로부터 30일 이내)</b></p>
                </div>
              </td>
              <td>
                <p class="semi-bold-text">2천만원 이상</p>
              </td>
            </tr>
            </tbody>

          </table>


<!--          <ul class="table table-2" style="border-bottom:none;">-->
<!--            <li class="justify-start" style="background-color: #fafafa">-->
<!--              <div>-->
<!--                -->
<!--                -->
<!--              </div>-->
<!--              <div>-->
<!--                <p class="px-4 bold-text">총 공사금액</p>-->
<!--              </div>-->
<!--            </li>-->
<!--            <li class="justify-start p-4 text-left">-->
<!--              <div>-->
<!--                <p class="normal-text ml-4">· 30일 이내에 종료되는 일시적 작업, 연간 총 작업일수가 60일을 초과하지 않는 간헐적 작업</p>-->
<!--                <p class="normal-text ml-4">· 자재·부품 납품, 우편물 배달 등</p>-->
<!--                <p class="normal-text ml-4">· 온·오프라인을 통한 사무용품 구매시 납품, 설치, 하자보수 등</p>-->
<!--                <p class="normal-text ml-4">· 용역제공 관련 회의 등 각종 회의 참석</p>-->
<!--                <p class="normal-text ml-4">· 사업장 내 정수기 설치, 생수공급 및 이와 유사한 업무</p>-->
<!--                <p class="normal-text ml-4">· 위험기계·기구 정기검사, 안전․ 보건관리대행, 안전보건․ 경영진단, 컨설팅, 행사, 교육    및 강의 등 사업장 내에서 수행하는 위탁 업무</p>-->
<!--                <p class="normal-text ml-4">· 기타 위와 유사한 출입업체가 수행하는 업무</p>-->
<!--              </div>-->
<!--            </li>-->
<!--          </ul>-->
        </vs-col>
      </vs-row>


    </div>
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'

export default {
  components: {
    FieldSelectModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FileUploadModule
  },
}
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  border: 1px solid #cdcdcd;
  border-collapse: collapse;
}

th,
td {
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  border: 1px solid #cdcdcd;
}

th {
  background: #f9f9f9;
  padding: 16px 6px;
}
tr {
  th:last-child,
  td:last-child {
    text-align: center;
  }
  td {
    div {
      padding: 20px;
    }
  }
}
p {
  margin: 5px 0;
}

.bold-text {
  font-weight: 700;
  font-size: 16px;
}
.semi-bold-text {
  font-weight: 500;
  font-size: 14px;
}

.normal-text {
  font-weight: 400;
}
</style>
